package components.items

import core.enums.EImages
import core.ionic.EmptyProps
import core.ionic.IonButton
import csstype.px
import emotion.react.css
import react.FC
import react.dom.html.ReactHTML
import react.router.useNavigate

val BackButtonIcon = FC<EmptyProps> { props ->

    val mSrc = EImages.ARROW_BACK.mRelativePath

    val mNavigate = useNavigate()

    IonButton {
        fill = "clear"
        shape = "round"
        ReactHTML.img {
            css {
                height = 24.px
            }
            src = mSrc
        }
        onClick = {
            mNavigate.invoke(-1)
        }
    }
}